function joinString(...value: string[]) {
  return value.join('_');
}

function truncateString(value: string, length: number): string {
  if (value.length <= length) {
    return value;
  }

  return `${value.substring(0, length - 3)}...`;
}

export default function truncateDocumentTitle(value: string[], length = 100): string {
  if (value.length === 0) {
    return '';
  }

  if (value.length === 1 || value[value.length - 1].length > length) {
    return truncateString(value[value.length - 1], length);
  }

  let first = value[0];
  let last = value[value.length - 1];
  const middle = value.slice(1, value.length - 1);
  let removed = false;

  while (
    middle.length > 0 &&
    joinString(first, ...(removed ? ['...'] : []), ...middle, last).length > length
  ) {
    middle.shift();
    removed = true;
  }

  if (removed) {
    middle.unshift('...');
  }

  if (joinString(first, ...middle, last).length > length) {
    first = truncateString(first, 13);
  }

  if (joinString(first, ...middle, last).length > length) {
    last = truncateString(last, length - joinString(first, ...middle).length - 1);
  }

  return [first, ...middle, last].join('_');
}
